"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _Label = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var humps = _interopRequireWildcard(require("humps"));
var eventHandlerUtils = _interopRequireWildcard(require("../../../utils/eventHandlers"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.728 2.88a3.013 3.013 0 0 1 4.257 0l2.133 2.13a3.005 3.005 0 0 1 0 4.254l-2.412 2.406-9.186 9.172a1 1 0 0 1-.526.276l-4.626.849a2.005 2.005 0 0 1-2.34-2.301l.77-4.613a1 1 0 0 1 .28-.543l9.239-9.223 2.41-2.407zM18 9.55l1.704-1.701a1.005 1.005 0 0 0 0-1.424l-2.132-2.13a1.014 1.014 0 0 0-1.431 0l-1.702 1.7L18 9.55zm-4.977-2.143L4.718 15.7 4 19.995v.002h.001l.003.003h.003l4.32-.793 8.258-8.244-3.562-3.556z"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.7 5.286a1 1 0 0 1 .014 1.415l-9.527 9.701a1.984 1.984 0 0 1-2.83.01l-3.055-2.98A1 1 0 1 1 5.698 12l3.062 2.986.008.007L18.286 5.3a1 1 0 0 1 1.415-.013z"
  }));
};
CheckIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414z"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "placeholder": "placeholder_29YqX2",
  "icon": "icon_1jhyri",
  "edit-icon": "edit-icon_2cTYMF",
  "editIcon": "edit-icon_2cTYMF",
  "action": "action_36DJ3A",
  "field-container": "field-container_1yb1fu",
  "fieldContainer": "field-container_1yb1fu",
  "field": "field_5qcMAN",
  "editable": "editable_l6w38L",
  "disabled": "disabled__50U9X",
  "value-text": "value-text_S7bD04",
  "valueText": "value-text_S7bD04",
  "text-field": "text-field_2YBShu",
  "textField": "text-field_2YBShu",
  "error-msg": "error-msg_3PITRN",
  "errorMsg": "error-msg_3PITRN"
}; 
require('./EditableField.css');
var ASSET_FIELDS_MAX_LENGTH = 256;
var EditableField = function EditableField(_ref) {
  var value = _ref.value,
    onSaveValue = _ref.onSaveValue,
    valueValidator = _ref.valueValidator,
    placeholder = _ref.placeholder,
    fieldName = _ref.fieldName,
    renderIcon = _ref.renderIcon;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isDirty = _useState4[0],
    setIsDirty = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    isValueSaved = _useState8[0],
    setIsValueSaved = _useState8[1];
  var _useState9 = (0, _react.useState)(value !== null && value !== void 0 ? value : ''),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    valueText = _useState10[0],
    setValueText = _useState10[1];
  (0, _react.useEffect)(function () {
    setValueText(value !== null && value !== void 0 ? value : '');
  }, [value]);
  var leaveEditState = function leaveEditState() {
    setValueText(value !== null && value !== void 0 ? value : '');
    setIsEditing(false);
    setIsDirty(false);
  };
  (0, _react.useEffect)(function () {
    // Create an scoped async function in the hook
    function runAsyncSaveValue() {
      return _runAsyncSaveValue.apply(this, arguments);
    } // Execute the created function directly
    function _runAsyncSaveValue() {
      _runAsyncSaveValue = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onSaveValue(valueText);
            case 2:
              setIsLoading(false);
              setIsEditing(false);
              setIsDirty(false);
              setIsValueSaved(false);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _runAsyncSaveValue.apply(this, arguments);
    }
    if (isValueSaved) {
      runAsyncSaveValue();
    }
  }, [isValueSaved]);
  var fieldId = humps.decamelize(fieldName, {
    separator: '-'
  });
  var fieldLabel = humps.decamelize(fieldName, {
    separator: ' '
  });
  var editFieldRef = (0, _react.useRef)(null);
  var editValue = function editValue() {
    if (!isLoading) {
      setIsEditing(true);
      editFieldRef.current.focus();
    }
  };
  var saveValue = function saveValue() {
    if (valueText === value) {
      leaveEditState();
    } else {
      var _valueValidator = valueValidator(valueText),
        isValid = _valueValidator.isValid;
      if (isValid) {
        setIsLoading(true);
        setIsValueSaved(true); // It triggers a useEffect
      }
    }
  };
  var handleOnchange = function handleOnchange(event) {
    setIsDirty(true);
    if (event.value.trim() === '') {
      setValueText(event.value);
    } else {
      setValueText(event.value.trim());
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      leaveEditState();
    }
    eventHandlerUtils.onEnterKey(saveValue)(event);
  };
  var renderPlaceHolder = function renderPlaceHolder() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: styles.placeholder,
      "data-test-id": "".concat(fieldId, "-placeholder")
    }, placeholder);
  };
  var renderValueText = function renderValueText() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: styles.valueText,
      "data-test-id": "".concat(fieldId, "-value"),
      title: valueText
    }, valueText);
  };
  var renderText = function renderText() {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: editFieldRef,
      role: "button",
      "aria-label": "Edit asset ".concat(fieldLabel),
      "data-test-id": fieldId,
      tabIndex: 0,
      className: (0, _classnames.default)(styles.field, (0, _defineProperty2.default)({}, styles.disabled, isLoading), (0, _defineProperty2.default)({}, styles.editable, !isLoading)),
      onClick: !isLoading ? editValue : null,
      onKeyDown: !isLoading ? eventHandlerUtils.onEnterKey(editValue) : null
    }, !!valueText ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "".concat(fieldId, "-icon"),
      className: styles.icon,
      size: "s",
      "aria-hidden": true
    }, renderIcon()) : null, valueText ? renderValueText() : renderPlaceHolder(), !isLoading ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "edit-".concat(fieldId, "-icon"),
      className: styles.editIcon,
      size: "xs"
    }, /*#__PURE__*/_react.default.createElement(EditIcon, null)) : null);
  };
  var renderEdit = function renderEdit() {
    var _valueValidator2 = valueValidator(valueText),
      isValid = _valueValidator2.isValid,
      errorMessage = _valueValidator2.errorMessage;
    var hasError = isDirty && !isValid;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.field)
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: "visually-hidden",
      htmlFor: fieldId
    }, fieldLabel), /*#__PURE__*/_react.default.createElement(_TextField.default, {
      id: fieldId,
      testId: "edit-".concat(fieldId),
      "aria-invalid": hasError,
      name: fieldId,
      type: "text",
      className: (0, _classnames.default)(styles.textField, hasError ? styles.error : ''),
      isDirty: hasError,
      isValid: isValid,
      onChange: handleOnchange,
      onKeyDown: handleKeyDown,
      value: valueText,
      placeholder: value,
      maxLength: ASSET_FIELDS_MAX_LENGTH,
      autoFocus: true
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "save-action-".concat(fieldId),
      role: "button",
      "aria-label": "Save ".concat(fieldLabel),
      tabIndex: "0",
      className: (0, _classnames.default)(styles.action),
      size: 20,
      onClick: saveValue,
      onKeyDown: eventHandlerUtils.onEnterKey(saveValue)
    }, /*#__PURE__*/_react.default.createElement(CheckIcon, null)), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "cancel-action-".concat(fieldId),
      role: "button",
      "aria-label": "Cancel edit ".concat(fieldLabel),
      tabIndex: "0",
      className: (0, _classnames.default)(styles.action),
      size: 20,
      onClick: leaveEditState,
      onKeyDown: eventHandlerUtils.onEnterKey(leaveEditState)
    }, /*#__PURE__*/_react.default.createElement(CloseIcon, null))), hasError ? /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles.errorMsg),
      "data-test-id": "error-".concat(fieldId)
    }, errorMessage) : null);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.fieldContainer
  }, isEditing ? renderEdit() : renderText());
};
var _default = exports.default = EditableField;
//# sourceMappingURL=EditableField.js.map